import { useSelector } from "react-redux";
import {
  selectDashboardVehicleStatus,
  selectDashboardVehicleStatusError,
  selectDashboardVehicleStatusLoading,
} from "Redux/Dashboard/slice";
import { StatusCount } from "Shared/Types/dashboard";

const statusPresentation: Record<string, { name: string; color: string }> = {
  active: { name: "Active", color: "var(--dashboard-success)" },
  in_shop: { name: "In shop", color: "var(--dashboard-warning)" },
  out_of_service: { name: "Out of service", color: "var(--dashboard-danger)" },
  inactive: { name: "Inactive", color: "var(--dashboard-muted)" },
  downtime: { name: "Downtime", color: "var(--dashboard-accent)" },
  sold: { name: "Sold", color: "var(--dashboard-violet)" },
  yes: { name: "Legacy status", color: "var(--dashboard-muted)" },
};

export const useVehicleStatus = () => {
  const vehicleStatus = useSelector(selectDashboardVehicleStatus);
  const loading = useSelector(selectDashboardVehicleStatusLoading);
  const error = useSelector(selectDashboardVehicleStatusError);
  const entries: [string, StatusCount][] = Object.entries(vehicleStatus);
  const statuses = entries
    .filter(([, item]) => Number.isFinite(item?.count) && item.count >= 0)
    .map(([key, item]) => ({
      key,
      value: item.count,
      ...(statusPresentation[key] || {
        name: key.replace(/_/g, " "),
        color: "var(--dashboard-muted)",
      }),
    }))
    .sort((a, b) => b.value - a.value);

  return { statuses, loading, error };
};
